import { Card } from "antd";
import styled from "styled-components";
import {colors} from "../../util/colors.ts";
import {useNavigate} from "react-router-dom";
import {SilverButton} from "../../components/LayoutWrapperCandidate.tsx";

export const AiPreview = () => {
    const navigate = useNavigate();


    return (
        <OverlayWrapper>
            <Card
                style={{
                    width: "360px",
                    margin: "auto",
                    borderRadius: 12,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
                bodyStyle={{ padding: "24px" }}
            >
                <BannerTitle>
                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>
                        Dieses Feature nutzen mit
                    </h3>
                </BannerTitle>

                <p style={{ fontSize: "24px", fontWeight: "600", margin: "16px 0 8px" }}>
                    silver+
                </p>

                <p style={{ fontSize: "28px", fontWeight: "bold", color: "#1a1a1a" }}>
                    ab <strong style={{ fontSize: "36px" }}>6,99€</strong> <br/> <span style={{ fontSize: "16px" }}>im Monat</span>
                </p>

                <SilverButton
                    onClick={() => navigate("/silverplus")}
                >
                    HIER GEHT'S WEITER
                </SilverButton>
            </Card>
        </OverlayWrapper>
    );
};

const OverlayWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 15px;
    @media (max-width: 767px) {
        height: calc(100vh - 200px);
    }
`;

const BannerTitle = styled.div`
    border: 1px solid ${colors.main};
    border-radius: 32px;
`;
